import React, { useState } from "react";
import { useLocalization } from '../../utils/hooks/useLocalization'
import styles from './SizeTableCollapsible.module.css';

const SizeTableCollapsible = ({ data, isMobile }) => {
  const [open, setOpen] = useState(false);
  const { t } = useLocalization();

  const translations = {
    "height": t("product_detail_height"),
    "length": t("product_detail_length"),
  }

  const measureKeys = Object.keys(data[Object.keys(data)[0]] || {});

  return (
    <div className={styles.sizeTableBox}>
      <button className={styles.primaryBtn} onClick={() => setOpen(!open)}>
        SIZE GUIDE
        <span className={styles.toggleSymbol}>{open ? "−" : "+"}</span>
        SIZE GUIDE
        <span className={styles.toggleSymbol}>{open ? "−" : "+"}</span>
        SIZE GUIDE
        {!isMobile ? <>
          <span className={styles.toggleSymbol}>{open ? "−" : "+"}</span>
          SIZE GUIDE
        </>
        : null}
      </button>

      {open && (
        <div className={styles.sizeTableContent}>
            <table className={styles.sizeTable}>
                <thead>
                <tr>
                    <th className={styles.firstCell}>{t('product_detail_size')}</th>
                    {measureKeys.map((m) => (
                    <th key={m}>{translations[m]?.toUpperCase() || m.toUpperCase()}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {Object.entries(data).map(([size, values], i) => (
                    <tr key={size}>
                    <td><strong>{size}</strong></td>
                    {measureKeys.map((m, j) => (
                        <td className={
                            i === Object.entries(data).length - 1 && j === measureKeys.length - 1
                            ? styles.lastCell
                            : ''} key={m}>{values[m]}</td>
                    ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
      )}
    </div>
  );
}

export default SizeTableCollapsible;